import { Pipe, PipeTransform } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'orderIsStorno',
  standalone: true,
})
export class OrderIsStornoPipe implements PipeTransform {
  public transform(order: OrderData): boolean {
    if (order) {
      return !!order.matchedImportStorno;
    }
    return false;
  }
}
